import { createSelector } from 'reselect'
import createIsCardOverdueSelector from './createIsCardOverdueSelector'
import createCardDateConflictsSelector from './createCardDateConflictsSelector'
import createOverdueChildCardsSelector from './createOverdueChildCardsSelector'
import createOverduePreviousCardsSelector from './createOverduePreviousCardsSelector'

// [
//   (state, { cardId }) => state['view-board'].cards[cardId]?.blockerCount,
//   isCardOverdueSelector,
//   (state, { cardId }) => state.kanbo.previousBlockedCards[cardId],
//   (state, { cardId }) => state.kanbo.descendantBlockedCards[cardId],
//   cardDateConflictsSelector,
//   (state, { cardId }) => overdueChildCardsSelector(state, { cardId, descendantCardsDates: state['view-board'].cards[cardId]?.descendantCardsDates }),
//   (state, { cardId }) => overduePreviousCardsSelector(state, { cardId, previousCardsDates: state['view-board'].cards[cardId]?.previousCardsDates }),
// ],



  // (state) => state['view-board'].view,
  // (state) => state['view-board'].cards,
  // (state) => state['view-board'].cardStatuses.byId,


  // state.kanbo.cardRelations.byId[cardId]

  //descendantCardsDates: state['view-board'].cards[cardId]?.descendantCardsDates
//previousCardsDates: state['view-board'].cards[cardId]?.previousCardsDates

// [
//   (state, { cardId }) => state['view-board'].cards[cardId]?.isArchived,
//   (state, { cardId }) => state['view-board'].cards[cardId]?.isTemplate,
//   (state, { cardId }) => state['view-board'].cards[cardId]?.dueDate,
//   (state, { cardId }) => state['view-board'].cards[cardId]?.statusId,
//   (state, { cardId }) => state['view-board'].view[state['view-board'].cards[cardId]?.boardId]?.isClosed,
//   (state) => state['view-board'].cardStatuses.byId,
// ],

const createCardIssueLevelSelector = () => {
  const isCardOverdueSelector = createIsCardOverdueSelector()
  const cardDateConflictsSelector = createCardDateConflictsSelector()
  const overdueChildCardsSelector = createOverdueChildCardsSelector()
  const overduePreviousCardsSelector = createOverduePreviousCardsSelector()

  return createSelector<{
    cardId,
    blockerCount,
    isArchived,
    isTemplate,
    dueDate,
    statusId,
    isBoardClosed,
    cardStatusesById,
    previousBlockedCards,
    descendantBlockedCards,
    boardsById,
    cardsById,
    cardRelations,
    descendantCardsDates,
    previousCardsDates,
  }, any, IssueLevel | undefined>(
    [
      ({ blockerCount }) => blockerCount,
      ({ isArchived, isTemplate, dueDate, statusId, isBoardClosed, cardStatusesById }) => isCardOverdueSelector({
        isArchived,
        isTemplate,
        dueDate,
        statusId,
        isBoardClosed,
        cardStatusesById,
      }),
      ({ previousBlockedCards }) => previousBlockedCards,
      ({ descendantBlockedCards }) => descendantBlockedCards,
      ({ cardId, boardsById, cardsById, cardStatusesById }) => cardDateConflictsSelector({
        cardId,
        boardsById,
        cardsById,
        cardStatusesById,
      }),
      ({ cardId, cardRelations, descendantCardsDates, cardStatusesById, boardsById, cardsById }) => overdueChildCardsSelector({
        cardId,
        cardRelations,
        descendantCardsDates,
        cardStatusesById,
        boardsById,
        cardsById,
      }),
      ({ cardId, cardRelations, previousCardsDates, cardStatusesById, boardsById, cardsById }) => overduePreviousCardsSelector({
        cardId,
        cardRelations,
        previousCardsDates,
        cardStatusesById,
        boardsById,
        cardsById,
      }),
    ],
    (
      blockerCount,
      isCardOverdue,
      previousBlockedCards,
      descendantBlockedCards,
      cardDateConflicts,
      overdueChildCards,
      overduePreviousCards,
    ) => {
      if (
        blockerCount
      ) {
        return 'danger'
      }

      if (
        isCardOverdue ||
        previousBlockedCards?.length ||
        descendantBlockedCards?.length ||
        cardDateConflicts.length ||
        overdueChildCards.length ||
        overduePreviousCards.length
      ) {
        return 'warning'
      }

      return undefined
    }
  )
}

export default createCardIssueLevelSelector
